<template>
    <div v-if="create_mode && user_admin" class="animated fadeIn">

        <!-- 專案資訊 -->
        <div class="container-fluid">

            <b-row>
                <b-col md="2"></b-col>
                <b-col md="8">

                    <!-- 專案資訊 -->
                    <div class="proj-toolbox-area">
                        <h4 v-text="$t('menu.project_information')"></h4>
                        <p class="text-muted" v-text="$t('other.input_required')">* 為必填項目</p>
                        <b-form>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-pencil"></i>{{ $t('menu.name') }} *</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.name"
                                              :state="$tools.input.checkRequired(projInfo.name)"
                                              :maxlength="$tools.input.getInputMaxLength('project','name')" />
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.description') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-textarea type="text" v-model="projInfo.description" :rows="3" :max-rows="6"></b-form-textarea>
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="fa fa-clock-o"></i>{{ $t('menu.timezone') }} *</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-select v-if="user_admin" v-model="projInfo.timezone"
                                               :options="$moment.tz.names()"
                                               :select-size="4"></b-form-select>
                                <b-form-input v-else v-model="projInfo.timezone" :disabled="true"></b-form-input>
                            </b-input-group>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-home"></i>{{ $t('menu.address') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.address"
                                              :maxlength="$tools.input.getInputMaxLength('project','address')" />
                            </b-input-group>

                            <!-- 開始日期 -->
                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <i class="fa fa-calendar"></i>{{ $t('menu.start_date') }} *
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <div>
                                    <date-picker v-model="projInfo.start_date" :lang="$tools.lang.date_picker(language)"
                                        :clearable="false" :placeholder="$t('menu.select_date')" format="YYYY-MM-DD"></date-picker>
                                </div>
                            </b-input-group>

                            <!-- 專案到期日期 -->
                            <b-input-group class="mt-3">
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <i class="fa fa-calendar"></i>{{ $t('menu.expiry_date') }}
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <div>
                                    <date-picker v-model="projInfo.end_date" :lang="$tools.lang.date_picker(language)"
                                        :clearable="false" :placeholder="$t('menu.expiry_date')" format="YYYY-MM-DD"></date-picker>
                                </div>
                            </b-input-group>
                            <p class="err-msg">
                                * 修改專案開始日期會自動將專案到期日設為專案開始日期後 30 天
                            </p>

                            <b-input-group class="mb-3">
                                <b-input-group-prepend>
                                    <b-input-group-text><i class="icon-location-pin"></i>{{ $t('menu.location') }}</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input type="text" class="form-control" v-model.trim="projInfo.location"
                                              :placeholder="$t('other.location_description')"
                                              :maxlength="$tools.input.getInputMaxLength('project','location')" />
                            </b-input-group>

                            <p class="text-muted" v-text="$t('menu.map_coordinate')">地圖中心座標</p>
                            <b-row>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.latitude') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="number" step="0.000001" max="9999999" class="form-control"
                                                      v-model.trim="projInfo.latitude" />
                                    </b-input-group>
                                </b-col>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.longitude')
                                                }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="number" step="0.000001" max="9999999" class="form-control"
                                                      v-model.trim="projInfo.longitude" />
                                    </b-input-group>
                                </b-col>
                                <b-col :md="4">
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="fa fa-map-pin"></i>{{ $t('menu.map_zoom') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input type="number" step="0.0001" max="9999999" class="form-control"
                                                      v-model.trim="projInfo.zoom" />
                                    </b-input-group>
                                </b-col>
                            </b-row>

                            <br>

                            <!-- Admin 專案資訊 -->
                            <div class="proj-toolbox-area" v-if="user_admin">
                                <h4>Admin Tools</h4>

                                <!-- 面積、單位密度 -->
                                <UnitEditorArea :area="projInfo.area" defaultUnit="m2"
                                                :timezone="projInfo.timezone"
                                                @update-area="projInfo.area_default_unit = $event"
                                                pageType="project"></UnitEditorArea>


                                <!-- 專案上限數 -->
                                <div>
                                    <div class="block-sm">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend>
                                                <b-input-group-text><i class="fa fa-tachometer"></i>{{ $t('n.cropping_season') }} {{ $t('menu.limit') }} *</b-input-group-text>
                                            </b-input-group-prepend>
                                            <b-form-input type="number" step="1" max="99" class="form-control"
                                                            v-model.trim="projInfo.cropperiod_max_limit" />
                                        </b-input-group>
                                    </div>
                                </div>

                                <!-- 專案服務等級 -->
                                <div>
                                    <div class="block-sm">{{ $t('menu.service_level') }} *</div>
                                    <div class="block-sm">
                                        <b-form-radio-group v-model="projInfo.service_level" :plain="true" buttons>
                                            <b-form-radio v-for="(service_level, idx_service_level) in list_project_service_level" :key="idx_service_level"
                                                :value="service_level.value" :button-variant="service_level.buttonVariant">
                                                {{ $t('status.service_level.' + service_level.value) }}</b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                </div>

                                <!-- 專案狀態 -->
                                <div>
                                    <div class="block-sm">{{ $t('menu.status') }} *</div>
                                    <div class="block-sm">
                                        <b-form-radio-group v-model="projInfo.status" :plain="true" buttons>
                                            <b-form-radio v-for="(status, idx_status) in list_project_status" :key="idx_status"
                                                :value="status.value" :button-variant="status.buttonVariant">
                                                {{ $t('status.project.' + status.value) }}</b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                </div>

                                <!-- 專案備註 -->
                                <div>
                                    <br>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text><i class="icon-menu"></i>{{ $t('menu.admin_note') }}</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-textarea type="text" v-model="projInfo.note" :rows="1" :max-rows="6"></b-form-textarea>
                                    </b-input-group>
                                </div>




                            </div>
                            <!-- end Admin 專案資訊 -->

                            <b-alert :show="update_message != ''" :variant="( update_status == 'success' ? 'success' : 'danger' )" dismissible>
                                <div v-html="update_message"></div>
                            </b-alert>

                            <br>

                            <div class="text-center">
                                <b-button variant="success" class="px-4 btn-upload" v-text="$t('menu.new_project')"
                                          @click="create_project" :disabled="uploading || checkDisabled">建立新專案</b-button>
                            </div>


                        </b-form>
                    </div>
                    <!-- end 專案資訊 -->

                </b-col>
            </b-row><!-- end b-row -->




        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import UnitEditorArea from '@/views/components/UnitEditor_Area'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'projectManagement',
        components: {
            UnitEditorArea,
            DatePicker,
        },
        data: function () {
            return {

                uploading: false,
                create_mode: false,

                update_status: 'success',
                update_message: '',

                projInfo: {
                    name: '',
                    description: undefined,
                    timezone: undefined,
                    address: undefined,
                    location: undefined,
                    longitude: undefined,
                    latitude: undefined,
                    zoom: 18.6,

                    // New / Edit by Admin
                    cropperiod_max_limit: 3,
                    start_date: undefined,
                    end_date: undefined,
                    service_level: 'basic',
                    status: 'activate',
                    note: undefined,
                    payment: undefined,

                    area: undefined,
                    area_default_unit: undefined,
                },
            }
        },
        mounted() {
            if ( this.$route.name == 'New Project' )
            {
                this.create_mode = true;
                this.clearProjectInfo();
            }

        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'language': state => state.user.language,
                'cropperiod_default_limit': state => state.project.cropperiod_default_limit,
                'list_project_status': state => state.project.list_project_status,
                'list_project_service_level': state => state.project.list_project_service_level,
            }),

            checkDisabled() {
                if (this.$tools.input.checkRequired(this.projInfo.name) == false) return true;

                if (this.projInfo.cropperiod_max_limit == undefined || this.projInfo.cropperiod_max_limit == '') return true;
                if (this.projInfo.start_date == undefined || this.projInfo.start_date == '') return true;
                return false;
            },
        },
        watch: {

            'projInfo.cropperiod_max_limit': function (newVal, oldVal)
            {
                if ( newVal == undefined || newVal == '' || newVal > 99 ) this.projInfo.cropperiod_max_limit = this.cropperiod_default_limit
            },

            'projInfo.start_date': function (newVal, oldVal)
            {
                if ( newVal != undefined && newVal != '' ) this.projInfo.end_date = this.$tools.date.getDateShift( this.projInfo.start_date, 30, 'days', 'YYYY-MM-DD' )
            },

        },
        methods: {

            // 清除介面上的專案資料
            clearProjectInfo ()
            {
                this.projInfo.name          = ''
                this.projInfo.description   = undefined

                // 沒有時區就猜時區
                this.projInfo.timezone  = this.$moment.tz.guess()

                this.projInfo.address       = undefined
                this.projInfo.location      = undefined
                this.projInfo.longitude    = undefined
                this.projInfo.latitude      = undefined
                this.projInfo.zoom          = undefined

                // Default Value
                this.projInfo.zoom = 18.6;

                // New / Edit by Admin
                this.projInfo.cropperiod_max_limit = this.cropperiod_default_limit
                this.projInfo.service_level     = this.list_project_service_level[0].value // 'basic'
                this.projInfo.start_date        = this.$moment(new Date()).format('YYYY-MM-DD')
                this.projInfo.end_date          = this.$tools.date.getDateShift( this.projInfo.start_date, 30, 'days', 'YYYY-MM-DD' )
                this.projInfo.status            = this.list_project_status[0].value // 'activate'
                this.projInfo.note              = undefined
                this.projInfo.payment           = undefined

                this.projInfo.area              = undefined
                this.projInfo.area_default_unit = this.projInfo.area
            },


            // 建立新專案
            create_project ()
            {
                this.uploading = true;
                this.update_message = ''

                let _data = {
                    name:                   this.projInfo.name,
                    timezone:               this.projInfo.timezone,
                    start_date:             this.$tools.date.dataTimeZone_to_UTC( this.projInfo.start_date, this.projInfo.timezone ), // 轉成 UTC time
                    end_date:               this.$tools.date.dataTimeZone_to_UTC( this.projInfo.end_date,   this.projInfo.timezone ), // 轉成 UTC time
                    service_level:          this.projInfo.service_level,
                    status:                 this.projInfo.status,
                    note:                   this.projInfo.note,
                    cropperiod_max_limit:   this.projInfo.cropperiod_max_limit,
                }
                // 非必填欄位
                if (this.projInfo.area_default_unit) { _data.area = this.projInfo.area_default_unit; } // 上傳換算後的數值 - 面積
                this.projInfo.area = undefined // 清除輸入介面 - 面積

                if (this.projInfo.description)       { _data.description = this.projInfo.description; }
                if (this.projInfo.address)           { _data.address     = this.projInfo.address; }
                if (this.projInfo.location)          { _data.location    = this.projInfo.location; }
                // if (this.projInfo.payment)           { _data.payment = this.projInfo.payment; }

                let _latitude   =  parseFloat( this.projInfo.latitude )
                let _longitude =  parseFloat( this.projInfo.longitude )
                if (this.projInfo.latitude)          { _data.latitude    = _latitude.toFixed(6); }
                if (this.projInfo.longitude)        { _data.longitude  = _longitude.toFixed(6); }
                if (this.projInfo.zoom)              { _data.zoom        = parseFloat( this.projInfo.zoom ).toFixed(2); }

                const options = {
                    method: 'POST',
                    url: this.$config.getAPI_URL('Projects', {}),
                    data: _data
                }
                this.$http(options)
                    .then(res => {
                        this.uploading = false;
                        this.$toastr.s(this.$t('other.update_succeeded'), this.$t('menu.project_information'));

                        this.update_status = 'success'
                        this.update_message =  `Project Created:<br>
                        ${ this.projInfo.name }　　${ this.projInfo.service_level }　　${ this.projInfo.start_date }-${ this.projInfo.end_date }`

                        // 重新取得現有專案列表
                        this.$store.dispatch('project/getProjects', { sort: 'project_name' })
                            .then(  res => {})
                            .catch( err => {})
                    })
                    .catch(err => {
                        this.uploading = false;
                        this.$toastr.e(this.$t('other.update_failed'), this.$t('menu.project_information'));

                        this.update_status = 'failed'
                        this.update_message =  `Failed:<br>
                        ${ this.projInfo.name }　　${ this.projInfo.service_level }　　${ this.projInfo.start_date }-${ this.projInfo.end_date }`
                    })

                // 送出使用者操作紀錄 --------------------
                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'project',
                        action: 'create project',
                        querySettings: {
                            'project name':         this.projInfo.name,
                            // 'project description':  this.projInfo.description,
                            'project status':       this.projInfo.status,
                            'service level':        this.projInfo.service_level,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            },




        },
    }

</script>

<style lang="scss" scoped>
    .toolbox-cover {
        margin-top: -38px;
        text-align: center;
    }

    .toolbox-logo {
        display: inline-block;
    }

    .toolbox-logo-edit {
        width: 100%;
    }

</style>
